module.exports = __webpack_public_path__ + "img/pay2.12c69657.jpg";